import React, { useEffect, useMemo, useState } from "react";
import { Container, Box, useTheme, Tabs, Tab } from "@mui/material";
import { FolderShared, Public, Lock } from "@mui/icons-material";
import UserProjects from "./UserProjects";
import { T } from "../../components/T";
import ProjectsByStatus from "./ProjectsByStatus";

type ProjectsPageProps = {
  view: "user" | "admin";
};

const ProjectsPage = ({ view }: ProjectsPageProps) => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState(0);

  const tabs = useMemo(
    () =>
      view === "user"
        ? [
            {
              label: <T str="My Projects" />,
              icon: <FolderShared />,
              content: <UserProjects />,
            },
            {
              label: <T str="Public Projects" />,
              icon: <Public />,
              content: <ProjectsByStatus status="PUBLIC" />,
            },
          ]
        : [
            {
              label: <T str="Private Projects" />,
              icon: <Lock />,
              content: <ProjectsByStatus status="PRIVATE" />,
            },
            {
              label: <T str="Shared Projects" />,
              icon: <FolderShared />,
              content: <ProjectsByStatus status="SHARED" />,
            },
            {
              label: <T str="Public Projects" />,
              icon: <Public />,
              content: <ProjectsByStatus status="PUBLIC" />,
            },
          ],
    [view]
  );

  useEffect(() => {
    setActiveTab(0);
  }, [view]);

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        px: "10%",
        bgcolor: theme.palette.background.default,
        color: theme.palette.text.primary,
        display: "flex",
        flexDirection: "column",
        flex: 1,
        overflow: "hidden",
        minHeight: 0,
      }}
    >
      <Tabs
        value={activeTab}
        onChange={(_, v) => setActiveTab(v)}
        textColor="secondary"
        indicatorColor="secondary"
        centered
        variant="fullWidth"
        sx={{
          width: "100%",
          maxWidth: 700,
          mx: "auto",
          "& .MuiTab-root": {
            fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
            minWidth: { xs: 100, sm: 180, md: 220 },
            textTransform: "none",
            gap: 1,
          },
        }}
      >
        {tabs.map((t, i) => (
          <Tab key={i} icon={t.icon} iconPosition="start" label={t.label} />
        ))}
      </Tabs>

      <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
        {tabs[activeTab]?.content}
      </Box>
    </Container>
  );
};

export default ProjectsPage;
